import { memo, useLayoutEffect, useRef } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import * as React from 'react';
import { Input } from './inputs';
import { styled } from '../../theme';

export interface SingleOTPInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean;
  error?: boolean;
}

export function SingleOTPInputComponent(props: SingleOTPInputProps) {
  const { focus, autoFocus, error, ...rest } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return <S.StyledInput ref={inputRef} error={error} {...rest} />;
}

const BASE_LABEL = 'single-otp-input';
namespace S {
  export const StyledInput = styled(Input)`
    padding: 0px;
    height: 100%;
    label: ${BASE_LABEL};
    text-align: center;
  `;
}

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
